export default "__VITE_ASSET__CVSrIJCQ__"